import React, { ReactNode } from 'react'
import { useTranslation } from 'react-i18next'
import { Box } from '@node-space/ui-components'
import { Headline } from 'components/Text'
import { VerificationRouteKey } from 'types/verification'

export interface StepLayoutProps {
  stepKey: VerificationRouteKey
  children: ReactNode
}

export const StepLayout = ({ stepKey, children }: StepLayoutProps) => {
  const { t } = useTranslation()

  return (
    <Box>
      <Headline>{t(`verification.routes.${stepKey}`)}</Headline>
      {children}
    </Box>
  )
}
